module.exports = __webpack_public_path__ + "static/img/ggsc4.1e6aea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/ggsc4.jpg
// module id = gjTj
// module chunks = 0